import { Loader2 } from 'lucide-react';

export default function Loader({ label = 'Loading…', className = '' }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 py-24 text-ink-300 ${className}`}>
      <Loader2 className="animate-spin text-brand" size={32} />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function ErrorState({ message = 'Something went wrong.', onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-24 text-center text-ink-300">
      <p className="text-danger">⚠ {message}</p>
      {onRetry && (
        <button onClick={onRetry} className="btn-ghost !py-2 text-sm">Retry</button>
      )}
    </div>
  );
}
